<template>
  <el-dialog
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="800px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
    :append-to-body="true"
  >
    <span slot="title" class="el-dialog__title">
      <template v-if="DialogFormData.module == 'quotation'">
        {{ l("我要询价") }}
      </template>
      <template v-else-if="DialogFormData.module == 'purchase'">
        {{ l("我要报价") }}
      </template>
      <template v-else-if="DialogFormData.module == 'raise'">
        {{ l("我要拼单") }}
      </template>
    </span>
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-width="100px"
      label-position="left"
    >
      <el-row>
        <el-col
          v-if="
            DialogFormData.module == 'quotation' ||
            DialogFormData.module == 'raise'
          "
          :span="24"
          key="amount"
        >
          <el-form-item :label="l('采购量') + '：'" prop="amount">
            <el-input
              v-model="DialogFormData.amount"
              :placeholder="
                DialogFormData.module == 'raise'
                  ? l('请输入不小于起拼量的数字') +
                    ' ' +
                    business_detail.start_amount
                  : l('采购量')
              "
              :disabled="Type == 'View'"
            >
              <template slot="append">
                {{ business_detail.specification_amount[0].unit }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          v-else-if="DialogFormData.module == 'purchase'"
          :span="24"
          key="price"
        >
          <el-form-item :label="l('价格') + '：'" prop="price">
            <el-input
              v-model="DialogFormData.price"
              :placeholder="l('价格')"
              :disabled="Type == 'View'"
            >
              <template slot="append">
                {{ l("元") }}/{{ business_detail.specification_amount[0].unit }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="l('补充说明') + '：'" prop="extra_params">
            <el-input
              type="textarea"
              :rows="5"
              v-model="DialogFormData.extra_params"
              :placeholder="l('可以输入交货时间、交货地等补充说明')"
              :maxlength="100"
              :show-word-limit="true"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button type="primary" @click="submitForm">{{ l("确 定") }}</el-button>
      <slot :Hide="Hide" :id="DialogFormData.id"></slot>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "BusinessDialog",
  mixins: [dialogMixin],
  props: {
    business_detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      DialogFormData: {
        code: "", //询报价code
        business_code: "", //来源code
        module: "",
        amount: null,
        price: null,
        address: "",
        extra_params: "",
      },
      dialogRules: {
        price: [
          {
            required: true,
            message: this.l("请输入") + this.l("价格"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^([\d.])+$/.test(value)) {
                callback(new Error(this.l("请输入") + this.l("数字")));
              } else {
                callback();
              }
            },
          },
        ],
        amount: [
          {
            required: true,
            message: this.l("请输入") + this.l("采购量"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (
                this.DialogFormData.module == "raise" &&
                (this.DialogFormData.amount !=
                  Number(this.DialogFormData.amount) ||
                  this.DialogFormData.amount <
                    this.business_detail.start_amount)
              ) {
                callback(
                  new Error(
                    this.l("请输入不小于起拼量的数字") +
                      this.business_detail.start_amount
                  )
                );
              } else {
                if (!/^([\d.])+$/.test(value)) {
                  callback(new Error(this.l("请输入") + this.l("数字")));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        this.DialogFormData.business_code = this.business_detail.code;
        console.log("this.business_detail", this.business_detail);
        //修改历史询报价
        if (this.business_detail.business_action_code) {
          this.axios
            .get(
              `/api/business_action/${this.business_detail.business_action_code}/`
            )
            .then((response) => {
              this.DialogFormData = response;
              resolve();
            })
            .catch(() => {
              reject();
            });
        } else {
          //创建新的询报价
          //检查有没有资格发布询报价、参与拼单
          this.axios
            .get(`/api/business_action/check_business_action_chance/`, {
              params: {
                module: this.DialogFormData.module,
              },
            })
            .then(() => {
              resolve();
            });
        }
      });
    },
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        this.$emit("submitDialog", this.DialogFormData);
        this.Hide();
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

